export default __webpack_public_path__ + "static/cSKvkxbG-7f7d0e82d7f2bbc26bc3aac422fbcb23.svg";